import SiteMessageWidget from '../../../../common/javascripts/widgets/SiteMessageWidget';

// [billing:credit-card:update:dashboard]
var VideoMemberCreditCardUpdate = function (args) {
  var $form = $('#' + args.formId);
  var $responsePlaceHolder = $('#' + args.responsePlaceHolder);
  var $dashBoardRoute = args.memberDashboardUrl;

  $form.on(args.SUBMIT_AJAX_SUCCESS_EVENT, function (ev, response) {
    if (response.success) {
      var $dashBoardRedirectSuccessRoute =
        $dashBoardRoute + '?success=1&message=' + response.message;
      window.location.replace($dashBoardRedirectSuccessRoute);
    } else {
      var messageWidget = new SiteMessageWidget(
        response.message,
        SiteMessageWidget.TYPE.DANGER
      );
      $responsePlaceHolder.empty();
      messageWidget.Render($responsePlaceHolder);
      $('body').animate(
        { scrollTop: $($responsePlaceHolder).offset().top - 120 },
        'fast'
      );
    }
  });

  $form.on(args.SUBMIT_AJAX_ERROR_EVENT, function () {
    var messageWidget = new SiteMessageWidget(
      'An internal error has occured. Please try again',
      SiteMessageWidget.TYPE.DANGER
    );
    $responsePlaceHolder.empty();
    messageWidget.Render($responsePlaceHolder);
    $('body').animate(
      { scrollTop: $($responsePlaceHolder).offset().top - 120 },
      'fast'
    );
  });
};

window.VideoMemberCreditCardUpdate = VideoMemberCreditCardUpdate; // Exposes for SiteJavascriptWidgetView
window.dispatchEvent(new Event('VideoMemberCreditCardUpdate')); // Signals that definition is ready for use
